package com.devi3east.bashbuddy.features.events.requests

import kotlinx.serialization.Serializable

@Serializable
data class PauseTicketRequest(
    val paused: Boolean
)